module.exports = __webpack_public_path__ + "static/img/FullBodyXRAY6.6e627178.jpg";